import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import Loader from "./Loader.jsx";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div>
        <Loader size="small" />
      </div>
    );
  }

  // 🔑 Allow /verify even if not authenticated
  if (!isAuthenticated && !location.pathname.includes("verify")) {
    return <Navigate to="/" replace />;
  }

  // 🔑 Role-based restriction (but skip check if on /verify)
  if (requiredRole && user?.role !== requiredRole && !location.pathname.includes("verify")) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
